export enum MoviesSelectorMode {
  Selector = 'selector',
  Filter = 'filter',
}
